/**
 * L4E organization verification API (POLICY_ACCOUNT_SECURITY_LADDER rule 4,
 * DEV-1439). Verification gates invitation/roster issuance; sysadmins set it
 * from Community Settings → Basics.
 */

import { apiFetch } from "./client";

export interface OrgVerificationResponse {
  communityGuid: string;
  verifiedDirectly: boolean;
  verifiedAt: string | null;
  /** Self or an org ancestor verified — what the invitation gate uses. */
  effectivelyVerified: boolean;
}

export function fetchOrgVerification(
  communityGuid: string,
): Promise<OrgVerificationResponse> {
  return apiFetch<OrgVerificationResponse>(
    `/api/communities/${communityGuid}/org-verification`,
  );
}

/** Sysadmin only — server enforces. */
export function setOrgVerification(
  communityGuid: string,
  verified: boolean,
): Promise<OrgVerificationResponse> {
  return apiFetch<OrgVerificationResponse>(
    `/api/communities/${communityGuid}/org-verification`,
    { method: "PUT", body: JSON.stringify({ verified }) },
  );
}
